import { APPLICANT_ATTRIBUTION_BOTH, LIVING_SITUATIONS, REAL_ESTATE_USAGES } from 'cpool-constants';
import type { SchemaLoanRequestResolver_Get } from 'cpool-tables/backend-resolvers';

const SELF_OCCUPIED_USAGES: ReadonlyArray<string | null | undefined> = [
    REAL_ESTATE_USAGES.EIGENGENUTZT,
    REAL_ESTATE_USAGES.EIGENGENUTZT_UND_VERMIETET,
];

export const getHousingFlags = (lead: SchemaLoanRequestResolver_Get) => {
    const selfOccupied = (attribution: string) =>
        lead.haushalt.immobilien.some(
            (realEstate) =>
                realEstate.gehoertZuAntragsteller === attribution &&
                SELF_OCCUPIED_USAGES.includes(realEstate.nutzungsart),
        );

    return {
        hasSelfOccupiedRealEstateApplicant1: selfOccupied(APPLICANT_ATTRIBUTION_BOTH.ANTRAGSTELLER_1),
        hasSelfOccupiedRealEstateApplicant2: selfOccupied(APPLICANT_ATTRIBUTION_BOTH.ANTRAGSTELLER_2),
        hasSelfOccupiedRealEstateShared: selfOccupied(APPLICANT_ATTRIBUTION_BOTH.BEIDE),
        isLivingInOwnHouseApplicant1: lead.antragsteller1.wohnsituation.wohnart === LIVING_SITUATIONS.IM_EIGENEN_HAUS,
        isLivingInOwnHouseApplicant2: lead.antragsteller2?.wohnsituation.wohnart === LIVING_SITUATIONS.IM_EIGENEN_HAUS,
        isLivingInSharedHousehold:
            lead.antragsteller1.wohnsituation.gemeinsamerHaushalt === true ||
            lead.antragsteller2?.wohnsituation.gemeinsamerHaushalt === true,
    };
};
